// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UXYn","option":"styles_option__15Zk1","selected":"styles_selected__sruzd"};